import { LanguageSelection } from '../types';
import { LocalStorageKeys } from '../settings';
import { getLanguageFromPath } from './url';

export const getLanguageSelection = (): LanguageSelection => {
    let language: LanguageSelection|null = getLanguageFromPath();

    if (!language) language = localStorage.getItem(
            LocalStorageKeys.languageSelection) as LanguageSelection|null;

    if (!language) language = 'finnish';

    return language;
};
